export default __webpack_public_path__ + "static/media/File_New.3b6a6198.svg";